<template>
    <div>
        <div class="form-group">
            <page-title :title="$t('scheduler.calendar')"></page-title>
        </div>

        <hall-event-calendar :viewType="viewType">

        </hall-event-calendar>
    </div>
</template>

<script>
    import HallEventCalendar from '../../components/scheduler/HallEventCalendar';
    import PageTitle from '../../components/common/PageTitle';

    export default {
        props: {
            viewType: String,
            details: {
                type: Boolean,
                default: false
            },
        },
        components: {
            HallEventCalendar,
            PageTitle
        },
        data() {
            return {
               
            }
        },
        methods: {
            
        },
        mounted() {
            
        }
    }
</script>

<style scoped>
</style>
